import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

const defaultBlog = {
  blog: null,
  firm: null,
  blogName: null,
  blogType: null,
  blogStatus: null,
  createdBy: null,
  content: null,
  imageUrl: null,
  blogTags: null,
  scheduledOn: null,
  isSticky: false,
  sort: 0,
  isAllowComments: false,
  isIncludeShop: false,
  attachments: []
}
const defaultComment = {
  blogComment: null,
  blog: null,
  createdBy: null,
  content: null
}

export const blogStore = defineStore('blog', {
  state: () => ({
    loading: {
      blog: false,
      blogs: false,
      foundBlogs: false,
      comments: false,
      attachments: false
    },
    blogs: [],
    blogCount: 0,
    foundBlogs: [],
    blog: null,
    comments: [],
    comment: null,
    attachments: [],
    blogStatus: null,
    blogType: null,
    searchTerm: null,
    pageSize: 10,
    sortBy: 'desc',
    orderBy: 'createdBy'
  }),
  actions: {
    resetBlogs(firm) {
      this.blogs = []
      this.comments = []
      this.blogStatus = null
      this.blogType = null
      this.blog = JSON.parse(JSON.stringify(defaultBlog))
      this.blog.firm = firm
      this.comment = null
    },
    resetComments() {
      this.comments = []
    },
    resetAttachments() {
      this.attachments = []
    },
    initBlog(firm) {
      this.blog = JSON.parse(JSON.stringify(defaultBlog))
      this.blog.firm = firm
    },
    setBlog(data) {
      this.blog = data
    },
    updateBlog(data) {
      if (this.blog) {
        switch (data.name) {
          case 'firm':
            this.blog.firm = parseInt(data.value)
            break
          case 'blogType':
            this.blog.blogType = parseInt(data.value)
            break
          case 'blogStatus':
            this.blog.blogStatus = parseInt(data.value)
            break
          case 'blogName':
            this.blog.blogName = data.value
            break
          case 'createdBy':
            this.blog.createdBy = parseInt(data.value)
            break
          case 'content':
            this.blog.content = data.value
            break
          case 'imageUrl':
            this.blog.imageUrl = data.value
            break
          case 'blogTags':
            this.blog.blogTags = data.value
            break
          case 'scheduledOn':
            this.blog.scheduledOn = data.value
            break
          case 'isSticky':
            this.blog.isSticky = data.value
            break
          case 'sort':
            this.blog.sort = parseInt(data.value)
            break
          case 'isIncludeShop':
            this.blog.isIncludeShop = data.value
            break
          case 'isAllowComments':
            this.blog.isAllowComments = data.value
            break
        }
      }
    },
    initComment(blog) {
      this.comment = JSON.parse(JSON.stringify(defaultComment))
      this.comment.blog = blog
    },
    updateComment(data) {
      if (this.comment) {
        switch (data.name) {
          case 'blog':
            this.blog.blog = parseInt(data.value)
            break
          case 'createdBy':
            this.blog.createdBy = parseInt(data.value)
            break
          case 'content':
            this.blog.content = data.value
            break
        }
      }
    },
    setStatus(status) {
      this.blogStatus = status
    },
    setType(type) {
      this.blogType = type
      console.log('Set Type', this.blogType)
    },
    setSearchTerm(searchTerm) {
      this.searchTerm = searchTerm
    },
    setOrderBy(orderBy) {
      this.orderBy = orderBy
    },
    setSortBy(sortBy) {
      this.sortBy = sortBy
    },
    resetShow(data) {
      console.log('Reset Show Before', data)
      if (this.blogs) {
        this.blogs.forEach((element) => {
          element.id++
          element.showComment = false
          element.showAttachment = false
          if (parseInt(element.blog) === parseInt(data.blog)) {
            if (data.showAttachment) {
              element.showAttachment = true
            } else if (data.showComment) {
              element.showComment = true
            }
          }
        })
      }
      console.log('Reset Show After', this.blogs)
    },
    async getBlogs(options) {
      this.loading.blogs = true
      this.blogs = []
      let results = await api.get('blog/blogs', options)
      let cnt = 0
      this.blogCount = 0
      this.blogs = []
      if (results) {
        if (results !== '') {
          this.blogCount = parseInt(results.count)
          this.blogs = results.items
          if (this.blogs) {
            this.blogs.forEach((element) => {
              element.id = cnt
              element.showComment = false
              element.showAttachment = false
              cnt++
            })
          }
        }
      }
      this.loading.blogs = false
      console.log('Got Blogs', this.blogs)
      return results
    },
    async getBlog(blog) {
      this.loading.blog = true
      let results = await api.get(`blog/blog?blog=${blog}`)
      if (results) {
        if (results !== '') {
          this.blog = results
        }
      }
      this.loading.blog = false
      console.log('Got Blog', this.blog)
      return results
    },
    async searchBlogs(data) {
      this.loading.foundBlogs = true
      this.foundBlogs = []
      let results = await api.get(`blog/blogSearch?firm=${data.firm}&searchTerm=${data.search}`)
      if (results) {
        if (results !== '') {
          this.foundBlogs = results
        }
      }
      this.loading.foundBlogs = false
      return data
    },
    async saveBlog() {
      return await api.post('blog/saveBlog', this.blog)
    },
    async deleteBlog(blog) {
      return await api.post(`blog/deleteBlog?blog=${blog}`)
    },
    async getAttachments(data) {
      this.loading.attachments = true
      this.attachments = []
      let results = await api.get(`blog/attachments?blog=${data.blog}&blogComment=${data.blogComment}`)
      if (results) {
        if (results !== '') {
          this.attachments = results
        }
      }
      this.loading.attachments = false
      return data
    },
    async deleteAttachment(id) {
      return await api.post(`blog/deleteAttachment?blogAttachment=${id}`)
    },
    async getComments(blog) {
      this.loading.comments = true
      this.comments = []
      let results = await api.get(`blog/comments?blog=${blog}`)
      if (results) {
        if (results !== '') {
          this.comments = results
          if (Array.isArray(results)) {
            let blog = results[0].blog
            let found = this.blogs.find((x) => parseInt(x.blog) === parseInt(blog))
            if (found) {
              found.countComments = results.length
            }
          }
        }
      }
      this.loading.comments = false
    },
    async saveComment(data) {
      return await api.post('blog/saveComment', data)
    },
    async deleteComment(id) {
      return await api.post(`blog/deleteComment?blogComment=${id}`)
    }
  }
})
